/**
 * @fileoverview Contiene los servicios de consumo a la API para Cupones
 *
 * @version 1.0
 *
 * @author José Antonio Rodríguez Barceló
 *
 * @copyright Shuttle Express México
 *
 * Historial
 * ---------
 * La primera versión fue escrita por José Antonio Rodríguez Barceló
 */

import api from '@/services/api'
const END_POINT = '/cupones'

export default {
  /**
   * @name getCoupons
   * @description Obtiene un listado de documentos segun parametros
   *
   * @param {*} params campo1 -> Parametros para poblar el select
   * @returns {array} devuelve un arreglo de json con los documentos
   */
  getCoupons(params) {
    if (params != null) {
      return api.get(END_POINT + params)
    }

    return api.get(END_POINT)
  },

  /**
   * @name postCoupon
   * @description Se crea el cupón
   *
   * @param {*} jwt JSON Web Token válido
   * @param {*} body Input del formulario -> Propiedades para crear el cupón
   */
  postCoupon(body) {
    return api.post(END_POINT, body)
  },

  /**
   * @name patchCoupon
   * @description Se actualiza el cupón
   *
   * @param {*} jwt JSON Web Token válido
   * @param {*} body Input del formulario -> Propiedades para actualizar el cupón
   * @param {*} id this.editedItem._id -> id del cupón que se va a actualizar
   */
  patchCoupon(body, id) {
    return api.patch(END_POINT + '/' + id, body)
  },

  /**
   * @name deleteCoupon
   * @description Elimina un documento por su id
   *
   * @param {*} id _id -> id del documento que se va a eliminar
   * @returns {json} json con el resultado de eliminar el documento
   */
  deleteCoupon(id) {
    return api.delete(END_POINT + '/' + id)
  },

  /**
   * @name validateCoupon
   * @description Verifica si un cupón es válido
   *
   * @param {*} coupon cupón que se desea validar
   * @returns {json} json con el resultado de la validación
   */
  validateCoupon(coupon) {
    return api.get(END_POINT + '/estatus/' + coupon)
  },
}
